import { Icon } from '../../components/icons/Icon'
import type { Density } from './types'

export interface DensityToggleProps {
  density: Density
  onChange: (density: Density) => void
}

export function DensityToggle({ density, onChange }: DensityToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Row density"
      style={{ display: 'inline-flex', border: '1px solid var(--iw-border-strong)', borderRadius: 'var(--iw-radius)', overflow: 'hidden' }}
    >
      {(['compact', 'comfortable'] as const).map((option) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={density === option}
          className="iw-btn iw-btn--sm"
          style={{
            border: 'none',
            borderRadius: 0,
            background: density === option ? 'var(--iw-accent-subtle)' : 'var(--iw-surface)',
            color: density === option ? 'var(--iw-accent)' : 'var(--iw-text-muted)',
          }}
          onClick={() => onChange(option)}
        >
          <Icon name="rows" size={13} />
          <span style={{ textTransform: 'capitalize' }}>{option}</span>
        </button>
      ))}
    </div>
  )
}
